import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    resources: {
      en: {
        translation: require("../src/Languages/en/translation.json"),
      },
      ar: {
        translation: require("../src/Languages/ar/translation.json"),
      }
    }
  });

export default i18n;
